




import {Component, Vue} from 'vue-property-decorator'
import Tariffs from '../Tarification/Tariffs.vue';
import {TarificationTypes, TarificationTransports} from "@/store/tarification/types";

@Component({components: {Tariffs}})
export default class CustomProviderTariffs extends Vue{
  private partnerType: TarificationTypes = TarificationTypes.OPERATOR
  private tarificationTransport: TarificationTransports = TarificationTransports.CUSTOM
}
